import type { IUploadParams, MethodValue } from 'react-dropzone-uploader';

interface UploadApiResponse {
  file?: {
    url?: string;
    key?: string;
    method?: MethodValue;
  };
}

interface UploadParamsInput {
  file: File;
  apiToken?: string;
}

export interface LayerUploadParams extends IUploadParams {
  method: MethodValue;
  body: File;
  url: string;
  key: string;
}

const getLayerUploadParams = async ({ file, apiToken }: UploadParamsInput): Promise<LayerUploadParams> => {
  const headers: Record<string, string> = {
    Accept: 'application/json',
  };

  if (apiToken) {
    headers['X-ApiToken'] = apiToken;
  }

  const response = await fetch('/api/v2/file/upload_url.json', {
    credentials: 'include',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch upload URL (status ${response.status})`);
  }

  const body = await response.json() as UploadApiResponse;
  const uploadFile = body.file;

  if (!uploadFile?.url || !uploadFile?.key || !uploadFile?.method) {
    throw new Error('Upload URL response is missing required file fields');
  }

  return {
    method: uploadFile.method,
    body: file,
    url: uploadFile.url,
    key: uploadFile.key,
  };
};

export default getLayerUploadParams;
